<!-- Barra de botões / Menubar -->
<p-menubar>
  <ng-template pTemplate="start">
    <div [ngStyle]="{'color': auth.getCorEmpresaSel()}" style="font-size: 1.1rem; font-weight: bold; margin-left: 10px;">
      Código: {{ objSel?.id || '' }}
    </div>
  </ng-template>
  <ng-template pTemplate="end">
    <button pButton type="button" icon="pi pi-save" title="Salvar"
      class="button-margin" [disabled]="salvando" (click)="confirmar()">
    </button>
  </ng-template>
</p-menubar>

<div class="grid p-fluid m-0 px-2 pt-3 pb-3">

  <!-- Moeda (Always editable and lookup using FatorMoeda field metadata) -->
  <div class="col-12 field" *ngIf="getSysCampo('fatorMoeda') as sc">
    <label>Moeda</label>
    <app-lista-pesquisa
      [api]="sc.classeNomePesq"
      [obj]="fatorMoeda"
      [qtdProperties]="convertToArray(sc.formatoWeb).length"
      [larguraCampos]="convertToNumberArray(sc.formatoWebLarg)"
      [properties]="convertToArray(sc.formatoWeb)"
      [labels]="[sc.id.toString()]"
      [limpar]="false"
      [viewChek]="false"
      (atualizarObjPai)="atualizarFatorMoeda($event)">
    </app-lista-pesquisa>
  </div>

  <!-- Adiantamento em Moeda Estrangeira -->
  <div class="col-12 md:col-6 field">
    <label>Adiantam. Moeda</label>
    <p-inputNumber [(ngModel)]="totalAdiantamMoeda"
      [minFractionDigits]="2" [maxFractionDigits]="2"
      mode="decimal" [min]="0"
      (onInput)="onValorMoedaChange()"
      (onBlur)="onValorMoedaChange()">
    </p-inputNumber>
  </div>

  <!-- Adiantamento em R$ -->
  <div class="col-12 md:col-6 field">
    <label>Adiantamento R$</label>
    <p-inputNumber [(ngModel)]="totalAdiantam"
      [minFractionDigits]="2" [maxFractionDigits]="2"
      mode="decimal" [min]="0"
      (onInput)="onValorBrlChange()"
      (onBlur)="onValorBrlChange()">
    </p-inputNumber>
  </div>

  <!-- Observação -->
  <div class="col-12 field">
    <label>Observação</label>
    <textarea pInputTextarea [(ngModel)]="obs"
      maxlength="80" rows="3" [autoResize]="false">
    </textarea>
  </div>

</div>
